import react from "react";
import Header from "../Component/Header";
const TermsAndCondtion=()=>{

    return(<>
        <Header />
        <main className="bg-grey">
            <div class="container p-5">
                <h2>XPSurvey Terms and Conditions</h2>
                <h5><u><strong>Effective Date:</strong> Apr 01, 2024</u></h5>

                <p>These Terms and Conditions ("Terms") govern your access to and use of the XPSurvey website located at <a href="https://xprssurvey.com">https://xprssurvey.com</a> (the "Website") operated by XPSurvey ("we," "us," or "our").</p>

                <h6><u>1. Acceptance of Terms:</u></h6>
                <p>By accessing or using the Website, you agree to be bound by these Terms. If you disagree with any part of these Terms, you may not access or use the Website.</p>

                <h6><u>2. Use of the Website:</u></h6>
                <p>The Website is intended for users who are 13 years of age or older. You may not use the Website for any illegal or unauthorized purpose. You agree to comply with all applicable laws and regulations in your use of the Website.</p>


                <h6><u>3. User Accounts:</u></h6>
                <p>You may be required to create an account to access certain features of the Website. You are responsible for maintaining the confidentiality of your account information, including your password. You are also responsible for all activity that occurs under your account.</p>

                <h6><u>4. User Content:</u></h6>
                <p>You may be permitted to submit content (such as survey questions and answers) to the Website ("User Content"). You retain all ownership rights to your User Content. By submitting User Content, you grant us a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, publish, and distribute your User Content in connection with the Website.</p>

                <h6><u>5. Third-Party Content:</u></h6>
                <p>The Website may contain content provided by third parties ("Third-Party Content"). We do not control or endorse Third-Party Content, and we are not responsible for the accuracy, legality, or any other aspect of Third-Party Content.</p>

                <h6><u>6. Disclaimer of Warranties:</u></h6>
                <p>THE WEBSITE IS PROVIDED "AS IS" AND WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. WE DISCLAIM ALL WARRANTIES, INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE WEBSITE WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE WEBSITE IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.</p>

                <h6><u>7. Limitation of Liability:</u></h6>
                <p>WE WILL NOT BE LIABLE FOR ANY DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE WEBSITE, INCLUDING, BUT NOT LIMITED TO, DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES.</p>

                <h6><u>8. Termination:</u></h6>
                <p>We may terminate your access to the Website at any time, for any reason, without notice.</p>

                <h6><u>9. Governing Law:</u></h6>
                <p>These Terms shall be governed by and construed in accordance with the laws of India.</p>

                <h6><u>10. Entire Agreement:</u></h6>
                <p>These Terms constitute the entire agreement between you and us regarding your use of the Website.</p>

                <h6><u>11. Changes to Terms:</u></h6>
                <p>We may update these Terms from time to time. We will post any changes on the Website. We encourage you to review these Terms periodically for any updates.</p>

                <h6><u>12. Contact Us:</u></h6>
                <p>If you have any questions about this Privacy Policy, please contact us at <a href="support@xprssurvey.com">support@xprssurvey.com</a></p>
            </div>
        </main>
    </>)
}
export default TermsAndCondtion;